import { render } from "./AddUserForm.vue?vue&type=template&id=885c9112&scoped=true"
import script from "./AddUserForm.vue?vue&type=script&lang=js"
export * from "./AddUserForm.vue?vue&type=script&lang=js"

import "./AddUserForm.vue?vue&type=style&index=0&id=885c9112&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885c9112"]])

export default __exports__